<template>
  <div>
    <FormGroup
      :label="$t('ttlockForm.clientIdLabel')"
      small-label
      class="margin-bottom-3"
      :error-message="getFirstErrorMessage('client_id')"
    >
      <FormInput
        v-model="values.client_id"
        :placeholder="$t('ttlockForm.clientIdPlaceholder')"
        autocomplete="off"
      />
    </FormGroup>
    <FormGroup
      :label="$t('ttlockForm.clientSecretLabel')"
      small-label
      class="margin-bottom-3"
      :error-message="getFirstErrorMessage('client_secret')"
    >
      <FormInput
        v-model="values.client_secret"
        type="password"
        :placeholder="$t('ttlockForm.clientSecretPlaceholder')"
        autocomplete="new-password"
      />
      <template #helper>
        {{ $t('ttlockForm.clientSecretHelp') }}
      </template>
    </FormGroup>
    <FormGroup
      required
      :label="$t('ttlockForm.usernameLabel')"
      small-label
      class="margin-bottom-3"
      :error-message="getFirstErrorMessage('username')"
    >
      <FormInput
        v-model="values.username"
        :placeholder="$t('ttlockForm.usernamePlaceholder')"
        autocomplete="username"
      />
    </FormGroup>
    <FormGroup
      required
      :label="$t('ttlockForm.passwordLabel')"
      small-label
      class="margin-bottom-3"
      :error-message="getFirstErrorMessage('password')"
    >
      <FormInput
        v-model="values.password"
        type="password"
        :placeholder="$t('ttlockForm.passwordPlaceholder')"
        autocomplete="current-password"
      />
      <template #helper>
        {{ $t('ttlockForm.passwordHelp') }}
      </template>
    </FormGroup>
    <FormGroup
      :label="$t('ttlockForm.apiBaseUrlLabel')"
      small-label
      class="margin-bottom-3"
      :error-message="getFirstErrorMessage('api_base_url')"
    >
      <FormInput
        v-model="values.api_base_url"
        :placeholder="$t('ttlockForm.apiBaseUrlPlaceholder')"
      />
    </FormGroup>
    <p class="margin-top-2">{{ $t('ttlockForm.help') }}</p>
  </div>
</template>

<script>
import form from '@baserow/modules/core/mixins/form'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  mixins: [form],
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      values: {
        client_id: '',
        client_secret: '',
        username: '',
        password: '',
        api_base_url: '',
      },
      allowedValues: [
        'client_id',
        'client_secret',
        'username',
        'password',
        'api_base_url',
      ],
    }
  },
  validations() {
    return {
      values: {
        username: { required },
        password: { required },
      },
    }
  },
}
</script>
